import { render, staticRenderFns } from "./IconSvgAttachment.vue?vue&type=template&id=6a5078fe&scoped=true&"
import script from "./IconSvgAttachment.vue?vue&type=script&lang=js&"
export * from "./IconSvgAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5078fe",
  null
  
)

export default component.exports